import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import BuyerAuthModal from 'dpl/buyer_account/components/BuyerAuthModal';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';
import { exists } from 'dpl/shared/utils/object';
import { sendRudderstackEvent } from 'dpl/util/analytics';

export default function BuyerAuthModalContainer() {
  const currentUser = useCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [analyticsProps, setAnalyticsProps] = useState(null);

  const figoQuoteUrl = useSelector(({ server }) => server.figo_quote_url);

  function redirectToFigoSite() {
    window.open(figoQuoteUrl, '_blank');
  }

  function handleCloseClick() {
    setIsModalOpen(false);
    setAnalyticsProps(null);
  }

  function handleCtaClick({ currentTarget }) {
    const { viewFeature, viewFeatureLocation } = currentTarget.dataset;

    setAnalyticsProps({
      origin_view_feature: viewFeature,
      origin_view_feature_location: viewFeatureLocation
    });

    if (currentUser.isLoggedIn) {
      redirectToFigoSite();
    } else {
      setIsModalOpen(true);
    }
  }

  function handleSuccessfulAuth({ data }) {
    // For new users, this callback receives a data.user object
    const isNewUser = exists(data, 'user');

    if (isNewUser) {
      sendRudderstackEvent(
        ANALYTICS_EVENTS.ACCOUNT_CREATED_BY_BUYER,
        analyticsProps
      );
    }

    currentUser.fetch();
    handleCloseClick();
    redirectToFigoSite();
  }

  function getPriceCheckElements() {
    return document.querySelectorAll('[data-action="price-check"]');
  }

  useEffect(() => {
    function addPriceCheckHandlers() {
      getPriceCheckElements()?.forEach(button => {
        button.addEventListener('click', handleCtaClick);
      });
    }

    function removePriceCheckHandlers() {
      getPriceCheckElements()?.forEach(button => {
        button.removeEventListener('click', handleCtaClick);
      });
    }

    document.addEventListener('DOMContentLoaded', addPriceCheckHandlers);

    return removePriceCheckHandlers;
  }, [currentUser.isLoggedIn]);

  if (!isModalOpen) return null;

  return (
    <div className="BuyerAuthModalContainer">
      <BuyerAuthModal
        onCloseClick={handleCloseClick}
        onSuccessfulAuth={handleSuccessfulAuth}
      />
    </div>
  );
}
